
import { Model } from 'backbone';
import undoService	from 'UndoService.js'
import controlCollection    from 'ControlCollection.js'
import connectionController from 'ConnectionController.js';
import listService from 'ListService';
import constants from 'Constants';
import textConstants        from 'TextConstants';

class WorkflowModel extends Model {

    initialize() {

        //TODO: set Current Visual Control Model id as an attribute

        this.set({
            'widgetText': '',
            trackEnabled: true
        } );

        controlCollection.add(this);

        this.lastState(this.toJSON());

        this.set('undoAction', false, {silent: true});

        this.on('change', () => {
            if (this.get('undoAction')) {
                this.set('undoAction', false, {silent: true});
                this.lastState(this.toJSON());
            } else {
                const lastState = this._lastState;
                const newState = JSON.stringify(this.toJSON());

                undoService.add({
                    undo: () => {
                        const oldX = this.get('x');
                        const oldY = this.get('y');
                        this.set(JSON.parse(lastState), {silent: true});
                        // we want to ignore what was set for this, this is important to not register another undo
                        this.set('undoAction', true, {silent: true});
                        // we trigger change because all views listening need to update
                        this.trigger('change');

                        if (listService.mainKind === constants.KIND_WORKFLOW) {
                            connectionController.updateConnection(this, {
                                x1: this.get('x'),
                                x2: oldX,
                                y1: this.get('y'),
                                y2: oldY
                            });
                        }
                    },
                    redo: ()=> {
                        const oldX = this.get('x');
                        const oldY = this.get('y');
                        this.set(JSON.parse(newState), {silent: true});
                        // we want to ignore what was set for this, this is important to not register another undo
                        this.set('undoAction', true, {silent: true});
                        // we trigger change because all views listening need to update
                        this.trigger('change');

                        if (listService.mainKind === constants.KIND_WORKFLOW) {
                            connectionController.updateConnection(this, {
                                x1: this.get('x'),
                                x2: oldX,
                                y1: this.get('y'),
                                y2: oldY
                            });
                        }
                    }
                }, textConstants.UNDO_PROP_CHANGE);

                this.lastState(this.toJSON());
            }
        });

    }
    lastState(state){
        this._lastState = JSON.stringify(state);
    }

    resetLastState() {
        this.lastState(this.toJSON());
    }
    triggerChangeNoTracking() {
        this.set('undoAction', true, {silent: true});
        this.trigger('change');
    }
}

export default WorkflowModel;

